module.exports = __webpack_public_path__ + "static/js/2.70bc5781.chunk.worker.js"